import { connect } from 'react-redux';
import * as ProductModificationSelectors from 'state/productModificationForm/productModificationForm.selector';
import type { AppState } from 'state/state.model';

interface OwnProps {
  tabId: string;
}
interface StateProps {
  startingTimeInMillis: number;
  durationTimeInMillis: number;
}

export type PendingStatusProps = OwnProps & StateProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const durationTimeInMillis = ProductModificationSelectors.getApplyRequestDurationInMillis(state, tabId)!;
  const startingTimeInMillis = ProductModificationSelectors.getApplyRequestStartingTimeInMillis(state, tabId)!;

  return {
    durationTimeInMillis,
    startingTimeInMillis,
  };
};

export const connectPendingStatus = connect(mapStateToProps);
